export default __webpack_public_path__ + "static/media/ic_tail_40.ea83ae79.svg";